import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { NewDiscountFormState } from "../discount-models/NewDiscountFormState";
import { ITranslations } from "../../../_models/ITranslations";
import { TranslationService } from "../../../_services/translation.service";
import { DiscountManagementService } from "../../../_services/discount-management.service";
import { DiscountMethod } from "../discount-models/DiscountMethod";
import {
  ChildDiscountModel,
  ChildDiscountStatus,
} from "../discount-models/ChildDiscountModel";
import { ChildEvent } from "../../events-screen/event-page-models/child-event";

@Component({
  selector: "new-discount-form-summary",
  templateUrl: "./new-discount-form-summary.component.html",
  styleUrls: [
    "../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
    "./new-discount-form-summary.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDiscountFormSummaryComponent implements OnInit, OnDestroy {
  @Input("newDiscountFormState")
  public newDiscountFormState$: Observable<NewDiscountFormState>;
  @Output("updateDiscountEvent")
  public updateDiscountEvent: EventEmitter<NewDiscountFormState> = new EventEmitter<NewDiscountFormState>();
  public translations$: Observable<ITranslations>;
  public readonly DiscountMethod = DiscountMethod;
  public finalNumberOfSubsides: number = 0;
  private currentFormState: NewDiscountFormState;

  constructor(
    protected translationService: TranslationService,
    private discountManagementService: DiscountManagementService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {
    this.newDiscountFormState$.subscribe((state) => {
      this.currentFormState = state;
      let numberOfSubsides = 0;
      const selectedChildren = state.children || [];
      const childEvents = (state.event && state.event.childEvents) || [];

      selectedChildren.forEach((child) => {
        childEvents
          .filter(
            (pricing) =>
              pricing.isSelected && !this.alreadyHasDiscount(child, pricing)
          )
          .forEach((pricing) => {
            numberOfSubsides++;
          });
      });
      this.finalNumberOfSubsides = numberOfSubsides;
    });
  }

  public ngOnDestroy(): void {}
  public alreadyHasDiscount(child: ChildDiscountModel, pricing: ChildEvent) {
    return (
      child.childStatus === ChildDiscountStatus.HasSomeDiscounts &&
      child.discountEvents.some(
        (x) =>
          x.childEventId === pricing.childEventId.toString() && x.hasDiscount
      )
    );
  }
  public calculateExisingDiscountAmount(
    child: ChildDiscountModel,
    pricing: ChildEvent & { isSelected: boolean }
  ) {
    const event = child.discountEvents.find(
      (x) => x.childEventId === pricing.childEventId.toString()
    );
    return event.existingDiscount;
  }
  public calculateExisingFinalPrice(
    child: ChildDiscountModel,
    pricing: ChildEvent & { isSelected: boolean }
  ) {
    const event = child.discountEvents.find(
      (x) => x.childEventId === pricing.childEventId.toString()
    );
    return pricing.childEventPrice - event.existingDiscount;
  }

  public calculateFinalPrice(
    child: ChildDiscountModel,
    pricing: ChildEvent & { isSelected: boolean }
  ) {
    return this.discountManagementService.calculatePriceAfterDiscountFromData(
      pricing.childEventPrice,
      this.currentFormState.amount
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/new-discount-form-summary/new-discount-form-summary.component.ts